import { render } from "./ForumMain.vue?vue&type=template&id=3b663d5e&scoped=true"
import script from "./ForumMain.vue?vue&type=script&lang=js"
export * from "./ForumMain.vue?vue&type=script&lang=js"

import "./ForumMain.vue?vue&type=style&index=0&id=3b663d5e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b663d5e"]])

export default __exports__